import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class FlamingoMessageService {
    private readonly snackBar = inject(MatSnackBar);

    success(message: string): void {
        this.snackBar.open(message, undefined, { duration: 3000, panelClass: ['flamingo-snackbar-success'] });
    }

    error(message: string): void {
        this.snackBar.open(message, undefined, { duration: 5000, panelClass: ['flamingo-snackbar-error'] });
    }

    info(message: string): void {
        this.snackBar.open(message, undefined, { duration: 4000 });
    }

    warning(message: string): void {
        this.snackBar.open(message, undefined, { duration: 5000, panelClass: ['flamingo-snackbar-warning'] });
    }
}


